import type { getVerificationMissingData } from "../../services/api/onboarding/missingFields";

export type TaxVerificationMissingData = Awaited<
  ReturnType<typeof getVerificationMissingData>
>;
export type TaxVerificationAction =
  | { type: "fields"; requiredFields: string[] }
  | { type: "us-profile-fields" }
  | { type: "documents"; token: string }
  | { type: "us-profile-documents"; token: string }
  | { type: "none" };

// Preserve the hosted flow's precedence, including US-profile actions.
export function selectTaxVerificationAction(
  data: TaxVerificationMissingData
): TaxVerificationAction {
  if (data.requiredFields?.length)
    return { type: "fields", requiredFields: data.requiredFields };
  if (data.profiles?.US?.requiredFields?.length)
    return { type: "us-profile-fields" };
  if (data.completeOnboardingToken)
    return { type: "documents", token: data.completeOnboardingToken };
  if (data.profiles?.US?.completeOnboardingToken)
    return {
      type: "us-profile-documents",
      token: data.profiles.US.completeOnboardingToken
    };
  return { type: "none" };
}

export function isUsProfileAction(action: TaxVerificationAction) {
  return (
    action.type === "us-profile-fields" ||
    action.type === "us-profile-documents"
  );
}
